import { INTERVAL_TIMES } from 'constants/interval-times';
import {
  CONTENTA_AUTH0_ACCESS_TOKEN,
  CONTENTA_B2B_ORGANIZATION_ID,
  CONTENTA_TOKEN,
} from 'constants/storages-values';
import { useEffect, useState } from 'react';
import { authService } from 'services/Auth0Service';
import {
  getCheckSessionOptions,
  persistAuthResult,
} from 'utils/authTokenUtils';
import { getFromStorage, removeFromStorage } from 'utils/storageUtils';

const useContentaAuth = ({ authUser, setIsAuthenticated, setAuthUser }) => {
  const [token, setToken] = useState(null);

  const renewToken = () => {
    authService.checkSession(getCheckSessionOptions(), (err, result) => {
      if (err) {
        console.error('Erro ao renovar token:', err);
      } else {
        const { apiToken } = persistAuthResult(result);

        if (apiToken) setToken(apiToken);
      }
    });
  };

  const authenticateUser = (token = null) => {
    const accessToken =
      getFromStorage(CONTENTA_AUTH0_ACCESS_TOKEN) ||
      token ||
      getFromStorage(CONTENTA_TOKEN);

    if (!accessToken) {
      return;
    }

    authService.client.userInfo(accessToken, function (err, user) {
      if (err) {
        if (err.statusCode === 401 || err.statusCode === 403) {
          removeFromStorage(CONTENTA_TOKEN);
          removeFromStorage(CONTENTA_AUTH0_ACCESS_TOKEN);
          removeFromStorage(CONTENTA_B2B_ORGANIZATION_ID);
        }
        return;
      }
      if (user) {
        setIsAuthenticated(true);
        setAuthUser(user);
      }
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const isUserEmpty = Object.keys(authUser).length === 0;

      if (isUserEmpty) {
        authenticateUser();
        return;
      }

      renewToken();
    }, INTERVAL_TIMES.FIVE_MINUTES);
    // }, 10000);

    return () => clearInterval(interval);
  }, [authUser]);

  return {
    token,
  };
};

export default useContentaAuth;
